import './App.css';
import React, { useEffect } from 'react';
import Header from './Components/header';
import Hompage from './Home/index';
import Footer from './Components/Footer';
import Abountus from "../src/Aboutus/index";
import Contactus from './Contactus';
import Services from './Services';
import Climate from './Services/Climate';
import IT from './Services/IT';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Projects from './Projects';
import OurProduct from './OurProduct';
import PrivacyPolicy from './Home/Components/PrivacyPolicy';
import TermsOfServices from './Home/Components/TermsOfServices';
import Floz from './Home/Components/Floz';

// Scroll to Top Component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Router>
      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh"
      }}>
        <Header />
        
        {/* Yeh component har route change pe scroll ko top pe le jayega */}
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Hompage />} />
          <Route path='/Aboutus' element={<Abountus />} />
          <Route path='/Contactus' element={<Contactus />} />
          <Route path='/OurProduct' element={<OurProduct />} />
          <Route path='/Services' element={<Services />} />
          <Route path="/Services/Climate" element={<Climate />} />
          <Route path="/Services/IT" element={<IT />} />
          <Route path='/Projects' element={<Projects />} />
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfServices" element={<TermsOfServices />} />
          <Route path="/Floz" element={<Floz />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}

export default App;